import { render, staticRenderFns } from "./cheatsheet-controls.vue?vue&type=template&id=7faf6cf2&scoped=true&lang=pug&"
import script from "./cheatsheet-controls.vue?vue&type=script&lang=js&"
export * from "./cheatsheet-controls.vue?vue&type=script&lang=js&"
import style0 from "./cheatsheet-controls.vue?vue&type=style&index=0&id=7faf6cf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faf6cf2",
  null
  
)

export default component.exports